import { ChangeDetectionStrategy, Component, EventEmitter, HostAttributeToken, inject, Input, Output } from '@angular/core';
import { IconComponent, IconName } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss'],
	imports: [IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
	@Input()
	icon: IconName | undefined;

	@Input()
	enabled = true;

	@Input()
	ctrlClickEnabled = false;

	@Input()
	hovering = false;

	@Input()
	fullWidth = false;

	@Input()
	lowerHeight = false;

	@Input()
	autoHeight = false;

	@Output()
	clickit: EventEmitter<void> = new EventEmitter<void>();

	@Output()
	clickitCtrl: EventEmitter<void> = new EventEmitter<void>();

	iconRight: boolean;

	@Input()
	buttonType: 'primary' | 'secondary' | 'text' | 'text-hover' = 'primary';

	constructor() {
		const iconRight = inject(new HostAttributeToken('icon-right'), { optional: true });

		this.iconRight = iconRight !== null;
	}

	click(event: MouseEvent) {
		if (this.ctrlClickEnabled && (event.ctrlKey || event.metaKey)) this.clickitCtrl.emit();
		else this.clickit.emit();
	}
}
